export const getAppConfig = () => {
  return {
    page: {
      titleTemplate: (page?: string) => (page ? `${page} | Phản ánh hiện trường` : "Phản ánh hiện trường"),
    },
  }
}
